// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__33eOD","content":"styles_content__25Eme","selectAll":"styles_selectAll__ViTEI"};